import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { BasketballHero } from '@/components/basketball/BasketballHero';
import { PlayerResults } from '@/components/basketball/PlayerResults';
import { WhoItsFor } from '@/components/basketball/WhoItsFor';
import { Testimonials } from '@/components/basketball/Testimonials';
import { BasketballServices } from '@/components/basketball/BasketballServices';
import { AboutDillon } from '@/components/basketball/AboutDillon';
import { BasketballFAQ } from '@/components/basketball/BasketballFAQ';
import { BasketballCTA } from '@/components/basketball/BasketballCTA';
import ContactSection from '@/components/ContactSection';

export default function BasketballPage() {
  return (
    <div className="min-h-screen bg-black" data-testid="basketball-page">
      <Header />
      <BasketballHero />
      <PlayerResults />
      <WhoItsFor />
      <Testimonials />
      <BasketballServices />
      <AboutDillon />
      <BasketballFAQ />
      <BasketballCTA />
      <ContactSection />
      <Footer />
    </div>
  );
}
